<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6 xl4>
        <v-card light>
          <v-toolbar dark>
            <v-toolbar-title>重設密碼</v-toolbar-title>
          </v-toolbar>

          <v-form v-model="valid" @submit.prevent="reset">
            <v-card-text>
              <v-text-field
                v-model="form.email"
                :rules="[formRules.required, formRules.email]"
                label="帳號信箱"
                outlined
                prepend-inner-icon="mdi-account"
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="form.password"
                :rules="[formRules.required]"
                label="新密碼"
                outlined
                prepend-inner-icon="mdi-key"
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="passwordCheck"
                :rules="[formRules.required, passwordValidation]"
                label="再次確認新密碼"
                outlined
                prepend-inner-icon="mdi-key-star"
              ></v-text-field>

              <v-btn type="submit" :disabled="!valid" outlined large block class="mb-3">送出</v-btn>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { mapState, mapActions } from "vuex";

import adminApi from "@/api/admin";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      valid: false,

      passwordCheck: "",
      form: {
        email: "",
        password: "",
        validation_token: ""
      }
    };
  },

  computed: {
    passwordValidation() {
      return this.passwordCheck === this.form.password || "請再次確認新密碼";
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    reset() {
      adminApi
        .resetPassword(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            return;
          }

          this.set_snackbar({
            color: "success",
            text: "密碼變更成功"
          });

          setTimeout(() => {
            this.$router.push("/login");
          }, 3000);
        })
        .catch(err => {});
    }
  },

  mounted() {
    const vt = this.$route.query.vt;
    if (!vt) {
      this.$router.push("/login");

      return;
    }

    this.form.validation_token = this.$route.query.vt;
  }
};
</script>

<style lang="scss" scoped>
</style>
